import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

import { DialogService, SessionService } from '@hub-components';

import { Template } from '../../../apps/studio/app/models/template.model';

@Component({
  selector: 'template-card',
  templateUrl: 'template-card.component.html',
  styleUrls: ['template-card.component.less'],
})
export class TemplateCardComponent implements OnInit {
  @Input() template: Template;
  @Input() type: 'dashboard' | 'report';
  @Output() templateUpdate = new EventEmitter();
  @Output() templateDeleted = new EventEmitter();

  public burtAdmin: boolean = false;
  public menuItems: MenuItem[];

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private dialogService: DialogService,
  ) {
    this.burtAdmin = this.sessionService.user.role === 'burt_admin';
  }

  public ngOnInit() {
    this.initMenuItems();

    if (this.type === 'report') {
      this.initDatasetNames();
    }
  }

  public navigateToTemplate() {
    this.router.navigate(['new'], { queryParams: { edit: 1, template: this.template.id } });
  }

  public updateTemplate(params: { name: string, description: string, global: boolean }) {
    this.dialogService.closeDialog(`updateTemplateDialog-${this.template.id}`);
    const updatedTemplate = Object.assign(this.template, params);
    this.templateUpdate.emit(updatedTemplate);
  }


  private initMenuItems() {
    this.menuItems = [
      {
        label: 'Settings',
        icon: 'fa-solid fa-gear',
        command: () => this.openUpdateTemplateDialog(this.template.id),
      },
      {
        label: 'Edit',
        icon: 'fa-solid fa-pencil',
        routerLink: [this.type === 'report' ? `../${this.template.id}` : `../${this.template.dashboardId}`],
        queryParams: { edit: 1 },
      },
      {
        label: 'Delete',
        icon: 'fa-solid fa-trash',
        command: () => this.delete(this.template),
      },
    ];
  }

  private initDatasetNames() {
    if (this.type === 'report') {
      this.template['datasetNames'] = this.template['tables'].map(table => table.query.dataset);
    }
  }

  private openUpdateTemplateDialog(templateId: string) {
    this.dialogService.openDialog(`updateTemplateDialog-${templateId}`);
  }

  private delete(template) {
    if (confirm(`Do you want to delete ${template.name}?`)) {
      this.templateDeleted.emit(template);
    }
  }
}
